const form_name = 'resetPasswordForm';

const fields = {
  password: 'password',
  confirm_password: 'confirm_password',
  old_password: 'old_password',
};

export default {
  form_name,
  fields,
};



// WEBPACK FOOTER //
// ./src/app/main/reset-password/constants/reset-password-constants.js